var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.564 1.5C14.564 1.16848 14.6957 0.850537 14.9301 0.616116C15.1645 0.381696 15.4824 0.25 15.814 0.25H18.314C18.6455 0.25 18.9634 0.381696 19.1978 0.616116C19.4323 0.850537 19.564 1.16848 19.564 1.5V16.5H20.189C20.3547 16.5 20.5137 16.5658 20.6309 16.6831C20.7481 16.8003 20.814 16.9592 20.814 17.125C20.814 17.2908 20.7481 17.4497 20.6309 17.5669C20.5137 17.6842 20.3547 17.75 20.189 17.75H1.43896C1.2732 17.75 1.11423 17.6842 0.997023 17.5669C0.879813 17.4497 0.813965 17.2908 0.813965 17.125C0.813965 16.9592 0.879813 16.8003 0.997023 16.6831C1.11423 16.5658 1.2732 16.5 1.43896 16.5H2.06396V12.75C2.06396 12.4185 2.19566 12.1005 2.43008 11.8661C2.6645 11.6317 2.98244 11.5 3.31396 11.5H5.81396C6.14549 11.5 6.46343 11.6317 6.69785 11.8661C6.93227 12.1005 7.06396 12.4185 7.06396 12.75V16.5H8.31396V7.75C8.31396 7.41848 8.44566 7.10054 8.68008 6.86612C8.9145 6.6317 9.23244 6.5 9.56396 6.5H12.064C12.3955 6.5 12.7134 6.6317 12.9478 6.86612C13.1823 7.10054 13.314 7.41848 13.314 7.75V16.5H14.564V1.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.77b5de62.svg";
export { ForwardRef as ReactComponent };